import { ContentfulService } from '../services/contentfulClient';
import WelcomePageHeroBanner from './welcomePageHeroBannerEntity';
import WelcomePageHighlightBlock from './welcomePageHighlightBlockEntity';

const heroBannerContentTypeId = "welcomePageHeroBanner";
const welcomePageHighlightBlockContentTypeId = "welcomePageHighlightBlock";

const fetchWelcomePageHeroBannerAsync = (query?: object): Promise<WelcomePageHeroBanner> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: heroBannerContentTypeId
  }, query))
  .then(res => res.items)
    .then(mapToWelcomePageHeroBanner);
};
const mapToWelcomePageHeroBanner = (welcomePageHeroBanner: any): WelcomePageHeroBanner => {

  const heroBanner = new WelcomePageHeroBanner();
  heroBanner.titleText = welcomePageHeroBanner[0].fields.bannerTitle;
  heroBanner.linkText = welcomePageHeroBanner[0].fields.bannerLinkText;
  heroBanner.linkUrl = welcomePageHeroBanner[0].fields.bannerUrl;

  if (welcomePageHeroBanner[0].fields.bannerBackgroundImage) {
    heroBanner.bannerBackgroundImage = welcomePageHeroBanner[0].fields.bannerBackgroundImage.fields.file.url;
  }
  if (welcomePageHeroBanner[0].fields.urlTarget) {
    heroBanner.linkUrlTarget = welcomePageHeroBanner[0].fields.urlTarget;
  }
  
  return heroBanner;
};


export const fetchWelcomePageHighlightMainItemsAsync = (query?: object): Promise<WelcomePageHighlightBlock[]> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: welcomePageHighlightBlockContentTypeId,
    'fields.isMainHighlight': true,
    order: 'fields.id'
  }, query))
  .then(res => res.items)
    .then(mapToWelcomePageHighlightMainItems);
};
export const fetchWelcomePageHighlightSubMainItemsAsync = (query?: object): Promise<WelcomePageHighlightBlock[]> => {
  const contentfulClient = new ContentfulService();
  
  return contentfulClient.cdaClient.getEntries(Object.assign({
    content_type: welcomePageHighlightBlockContentTypeId,
    'fields.isMainHighlight': false,
    order: 'fields.id'
  }, query))
  .then(res => res.items)
    .then(mapToWelcomePageHighlightMainItems);
};
const mapToWelcomePageHighlightMainItems = (welcomePageHighlightBlockItems: any[]): WelcomePageHighlightBlock[] => {

  return welcomePageHighlightBlockItems.map(mapToWelcomePageHighlightMainItem);
};
const mapToWelcomePageHighlightMainItem = (welcomePageHighlightBlockItem: any): WelcomePageHighlightBlock => {

  const welcomePageHighlightBlock = new WelcomePageHighlightBlock();
  welcomePageHighlightBlock.id = welcomePageHighlightBlockItem.fields.id;
  welcomePageHighlightBlock.highlightTitle = welcomePageHighlightBlockItem.fields.highlightTitle;
  welcomePageHighlightBlock.highlightBody = welcomePageHighlightBlockItem.fields.highlightBody;
  welcomePageHighlightBlock.highlightUrlText = welcomePageHighlightBlockItem.fields.highlightUrlText;
  welcomePageHighlightBlock.highlightUrl = welcomePageHighlightBlockItem.fields.highlightUrl;
  welcomePageHighlightBlock.isMainHighlight = welcomePageHighlightBlockItem.fields.isMainHighlight;

  if (welcomePageHighlightBlockItem.fields.highlightImage) {
    welcomePageHighlightBlock.highlightImage = welcomePageHighlightBlockItem.fields.highlightImage.fields.file.url;
  }
  if (welcomePageHighlightBlockItem.fields.additionalHighlightBoxCssClass) {
    welcomePageHighlightBlock.additionalHighlightBoxCssClass = welcomePageHighlightBlockItem.fields.additionalHighlightBoxCssClass;
  }
  if (welcomePageHighlightBlockItem.fields.urlTarget) {
    welcomePageHighlightBlock.highlightUrlTarget = welcomePageHighlightBlockItem.fields.urlTarget;
  }
  
  return welcomePageHighlightBlock;
};

export const frontPageContentManager = {
    fetchWelcomePageHeroBannerAsync,
    fetchWelcomePageHighlightMainItemsAsync,
    fetchWelcomePageHighlightSubMainItemsAsync
};


// WEBPACK FOOTER //
// ./src/api/frontPageContentManager.ts